import { computed, Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SearchBarValue {
  // private TAG = 'SearchBarValue';
  private _searchBarValue: WritableSignal<string> = signal<string>('');
  public readonly searchBarValue = computed(() => this._searchBarValue());

  public setSearchBarValue(value: string): void {
    this._searchBarValue.set(value);
  }
}
